module.exports = "<div class=\"md2-tooltip {{_class}}\"\r\n    [style.transform-origin]=\"_transformOrigin\"\r\n    [@state]=\"_visibility\"\r\n    (@state.done)=\"_afterVisibilityAnimation($event)\"\r\n    [innerHTML]=\"message\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/_common/components/tooltip/tooltip.html
// module id = 775
// module chunks = 63